export default __webpack_public_path__ + "static/partnering-video-poster-045671200ec29fe06df1b5beafd1790a.jpg";